import React, { useState, useEffect } from 'react';
import  { Container, Row, Col, Button, Breadcrumb, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Header from '../page-layout/header/Header';
import NavMenu from '../navigation/Navmenu';
import Footer from '../page-layout/footer/Footer';
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { DeleteOrganization, DisableOrganization, EnableOrganization, GetOrganization, MultipleDeleteOrganization, ApproveOrganization, PermanentDeleteOrganization } from '../../utils/axios/CompanyAPI';
import { EnableUser } from '../../utils/axios/UserApi';
import { ConfirmAlert, TimerAlert, getRoles } from '../../utils/swtAlert';
import { Decrypt } from '../../utils/Helper';
import { GrokLoading } from "../page-layout/loading/Loading";
import { GetIndustryType } from '../../utils/axios/LookUpAPI';
import { ORGANIZATION_TYPE } from '../constants/constants';
import './Company.css'

const Company = () => {
    // eslint-disable-next-line no-unused-vars
    const [userInfo, setuserInfo] = useState(JSON.parse(Decrypt(sessionStorage.getItem('userInfo'))));
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [selectedData, setSelectedData] = React.useState();
    const [isChecked, setIsChecked] = useState(false);
    const [clearRows, setClearRows] = useState(false);
    const [isDisabledItem, setIsDisabledItem] = useState(false);
    const [isEnabledItem, setIsEnabledItem] = useState(false);
    const [role, setRole] = useState('');
    const [industryTypeList, setIndustryTypeList] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    
    const columns = [
        {
          name: "Industry Partner",
          width: "250px",
          selector:  row => row.Name,
          sortable:true,
          cell: row => row.Name,
        },
        {
          name: "Industry Partner Activities",
          width: "300px",
          selector:  row => row.Brief,
          sortable:true,
          cell: row => row.Brief,
          omit: (role === 'Grok Admin') ? true :false
        },
        {
          name: "Contact Person Name",
          width: "200px",
          selector: row => row.ContactName,
          sortable: true,
          cell: row => row.ContactName,
          omit: (role !== 'Grok Admin') ? true :false
        },
        {
          name: "Contact Person Email",
          width: "230px",
          selector: row => row.ContactEmail,
          sortable: true,
          cell: row => row.ContactEmail,
          omit: (role !== 'Grok Admin') ? true :false
        },
        {
            name: "Contact Number",
            width: "160px",
            selector: row => row.ContactNumber,
            sortable: true,
            cell: row => row.ContactNumber,
            omit: (role !== 'Grok Admin') ? true :false
        },
        {
            name: "Industry Vertical",
            width: "160px",
            selector: row => row.IndustryTypeShortString,
            sortable: true,
            cell: (row) =>(<>
                {row.HideTooltip?
                    <span>{row.IndustryTypeShortString}</span>
                    :
                    <span data-tooltip={row.IndustryTypeLongString}>
                        {row.IndustryTypeShortString+"..."}
                        <span><svg width="1.5em" height="1.5em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 6L15 12L9 18" stroke="#222222"/>
                        </svg></span>
                    </span>}
            </>),
        },
        {
            name: "Status",
            width: "150px",
            sortable: true,
            cell: (row) => (<>
                <button
                className="status_btn"
                title={ row.IsEnable === true ? "Enabled" : "Disabled"}
                style={{ background: row.IsEnable === true ? "#a7f3d0" : "#fecdd3", color:row.IsEnable === true ? "green" : "red" }}
                >
                <span>{row.IsEnable === true ? "Enabled" : "Disabled"}</span>
                </button>
            </>),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            omit: (role !== 'Grok Admin') ? true :false
        },{
            name: "Created By",
            width: "230px",
            alignItems: "center",
            selector: row => row.CreatedBy?.Name != null ? row.CreatedBy?.Name : "NA",
            sortable: true,
            cell: row => row.CreatedBy?.Name != null ? row.CreatedBy?.Name : "NA",
            omit: (role !== 'Grok Admin') ? true :false
        },
        {
            name: "Updated By",
            width: "230px",
            alignItems: "center",
            selector: row => row.UpdatedBy?.Name != null ? row.UpdatedBy?.Name : "NA",
            sortable: true,
            cell: row => row.UpdatedBy?.Name != null ? row.UpdatedBy?.Name : "NA",
            omit: (role !== 'Grok Admin') ? true :false
        },
        {
            name: "Actions",
            width: "200px",
            cell: (row) => (<>
              {/* <button className="btn btn-link" title="View"><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M255.66 112c-77.94 0-157.89 45.11-220.83 135.33a16 16 0 00-.27 17.77C82.92 340.8 161.8 400 255.66 400c92.84 0 173.34-59.38 221.79-135.25a16.14 16.14 0 000-17.47C428.89 172.28 347.8 112 255.66 112z"></path><circle cx="256" cy="256" r="80" fill="none" strokeMiterlimit="10" strokeWidth="32"></circle></svg></span></button> */}
              <button className="btn btn-link ms-1" title="Edit" onClick={() => handleCompanyEdit(row._id)}><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path d="M19.045 7.401c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.378-.378-.88-.586-1.414-.586s-1.036.208-1.413.585L4 13.585V18h4.413L19.045 7.401zm-3-3 1.587 1.585-1.59 1.584-1.586-1.585 1.589-1.584zM6 16v-1.585l7.04-7.018 1.586 1.586L7.587 16H6zm-2 4h16v2H4z"></path></svg></span></button>
              <button className="btn btn-link ms-1" title="Delete" onClick={() => handleButtonDelete(row._id)}><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z"></path></svg></span></button>
              <button className="btn btn-link ms-1" title="Accept" onClick={() => handleAcceptApplication(row._id,row.ContactEmail)} disabled={row.IsApproved===true}>
                <span>
                    <svg fill={ row.IsApproved === true ? "#E5E4E2" : "#000000"} height="1.0em" width="1.0em" xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512" enable-background="new 0 0 512 512">
                    <polygon points="437.3,30 202.7,339.3 64,200.7 0,264.7 213.3,478 512,94 "/>
                    </svg>
                </span>
              </button>
              <button className="btn btn-link ms-1" title="Reject" onClick={() => handleRejectApplication(row._id)} disabled={row.IsApproved===true}>
                <span>
                    <svg fill={ row.IsApproved === true ? "#E5E4E2" : "#000000"} height="1.0em" width="1.0em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15">
                    <path d="M2.64,1.27L7.5,6.13l4.84-4.84C12.5114,1.1076,12.7497,1.0029,13,1c0.5523,0,1,0.4477,1,1&#xA;&#x9;c0.0047,0.2478-0.093,0.4866-0.27,0.66L8.84,7.5l4.89,4.89c0.1648,0.1612,0.2615,0.3796,0.27,0.61c0,0.5523-0.4477,1-1,1&#xA;&#x9;c-0.2577,0.0107-0.508-0.0873-0.69-0.27L7.5,8.87l-4.85,4.85C2.4793,13.8963,2.2453,13.9971,2,14c-0.5523,0-1-0.4477-1-1&#xA;&#x9;c-0.0047-0.2478,0.093-0.4866,0.27-0.66L6.16,7.5L1.27,2.61C1.1052,2.4488,1.0085,2.2304,1,2c0-0.5523,0.4477-1,1-1&#xA;&#x9;C2.2404,1.0029,2.4701,1.0998,2.64,1.27z"/>
                </svg>
                </span>
              </button>
            </>),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            omit: (role !== 'Grok Admin') ? true :false
        },
    ]
    const [data, setData] = useState();
    const tableData = {
      columns,
      data,
    };

    const addCompany = () => {
      navigate('/industrypartnerdetails', {state: { companyid: null} });
    }

    const handleCompanyEdit = (id) => {
        navigate('/industrypartnerdetails', { state: {companyid: id}})
    }

    const BackBtn = () => {
        navigate('/home');
    }

    const handleButtonDelete = async (id) => {
        ConfirmAlert("You want to Delete Industry Partner!", 'Are you sure?', 'warning', 'Yes, delete this Industry Partner!').then(
            async (result) => {
                if (result.isConfirmed) {
                    const userId = userInfo._id;
                    var response = await DeleteOrganization(id, userId);
                    if (response) {
                        TimerAlert("success", "Industry Partner Deleted Successfully", "success");
                        getOrganization();
                    }
                }
            }
        )
    }

    const handleAcceptApplication = async (id,email) => {
        ConfirmAlert("You want to Enable Industry Partner!", 'Are you sure?', 'warning', 'Yes, Enable this Industry Partner!').then(
            async (result) => {
                if (result.isConfirmed) {
                    let enablePayload = {
                        OrganizationId: id,
                        UpdatedBy: userInfo._id
                    }
                    var response = await ApproveOrganization(enablePayload);
                    if (response) {
                        let emailPayload = {
                            Email: email,
                            UpdatedBy: userInfo._id
                        }
                        console.log(emailPayload);
                        var response2 = await EnableUser(emailPayload);
                        if (response2) {
                            TimerAlert("success", "Industry Partner and User Enable Successfully", "success");
                            getOrganization();
                        }
                        else {
                            TimerAlert("error", "Industry Partner Enable Successfully, User might have enabled before", "error");
                            getOrganization();
                        }
                    }
                    else {
                        TimerAlert("error", "Industry Partner Enable Failed", "error");
                    }
                }
            }
        )
    };

    const handleRejectApplication = async (id) => {
        ConfirmAlert("You want to Reject/Permanently Delete this Associate Industry Partner!", 'Are you sure?', 'warning', 'Yes, delete this Industry Partner!').then(
            async (result) => {
                if (result.isConfirmed) {
                    var response = await PermanentDeleteOrganization(id);
                    if(response){
                        TimerAlert("success", "Industry Partner and User Deleted Successfully", "success");
                        getOrganization();
                    }
                    else {
                        TimerAlert("error", "Industry Partner Deleted Failed", "error");
                    }
                }
            }
        )
    };

    const handleSelect = (state) => {
        var selectedRows = [];
        selectedRows.forEach(function(element) {
            selectedRows.push(state[element])
        });
        setSelectedData(state.selectedRows.map((item) => item._id));
        if (selectedData !== null) {
            if (state.selectedRows.map((item) => item._id).length === 0) {
                setIsChecked(false);
                setIsEnabledItem(false);
                setIsDisabledItem(false);
            }
            else if (state.selectedRows.every((item) => (item.IsEnable === true))) {
                setIsEnabledItem(true);
                setIsChecked(true);
                setIsDisabledItem(false);
            }
            else if (state.selectedRows.every((item) => (item.IsEnable === false))) {
                setIsEnabledItem(false);
                setIsChecked(true);
                setIsDisabledItem(true);
            }
            else if (state.selectedRows.map((item) => item.IsEnable).includes(true && false)) {
                setIsEnabledItem(false);
                setIsChecked(true);
                setIsDisabledItem(false);
            }
        }
    };
    
    const handleMultipleDelete = async (id) => {
        ConfirmAlert("You want to Delete Companies!", 'Are you sure?', 'warning', 'Yes, delete these Companies!').then(
            async (result) => {
                if (result.isConfirmed) {
                    let deletePayload = {
                        OrganizationIds: selectedData,
                        DeletedBy: userInfo._id
                    }
                    var response = await MultipleDeleteOrganization(deletePayload);
                    if (response) {
                        TimerAlert("success", "Companies Deleted Successfully", "success");
                        setClearRows(true);
                        getOrganization();
                        setIsChecked(false);
                        setIsEnabledItem(false);
                        setIsDisabledItem(false);
                    }
                }
            }
        )
    }

    const handleMultipleDisable = async (id) => {
        ConfirmAlert("You want to Disable Companies!", 'Are you sure?', 'warning', 'Yes, disable these Companies!').then(
            async (result) => {
                if (result.isConfirmed) {
                    let disablePayload = {
                        OrganizationIds: selectedData,
                        UpdatedBy: userInfo._id
                    }
                    var response = await DisableOrganization(disablePayload);
                    if (response) {
                        TimerAlert("success", "Companies Disabled Successfully", "success");
                        setClearRows(true);
                        getOrganization();
                        setIsChecked(false);
                        setIsEnabledItem(false);
                        setIsDisabledItem(false);
                    }
                }
            }
        )
    }

    const handleMultipleEnable = async (id) => {
        ConfirmAlert("You want to Enable Industry Partner!", 'Are you sure?', 'warning', 'Yes, Enable these Industry Partner!').then(
            async (result) => {
                if (result.isConfirmed) {
                    let enablePayload = {
                        OrganizationIds: selectedData,
                        UpdatedBy: userInfo._id
                    }
                    var response = await EnableOrganization(enablePayload);
                    if (response) {
                        TimerAlert("success", "Industry Partner Enable Successfully", "success");
                        setClearRows(true);
                        getOrganization();
                        setIsChecked(false);
                        setIsEnabledItem(false);
                        setIsDisabledItem(false);
                    }
                }
            }
        )
    }

    const addRefresh = () => {
        navigate('/home', {state: {companyid: null}});
    }

    const getOrganization = async () => {
        let organizationPayload = {
            OrganizationType:ORGANIZATION_TYPE.COMPANY
        }
        var organizationResponse = await GetOrganization(organizationPayload);
        processOrganizationData(organizationResponse.data);
        setData(organizationResponse.data);
        setFilteredData(organizationResponse.data);
        setLoading(false);
        setClearRows(false);
    }

    function processOrganizationData(Data){
        Data.forEach((item) => {
            item.HideTooltip = item.IndustryType.length>1 ? false : true;
            item.IndustryTypeLongString = item.IndustryType.length>0 ? item.IndustryType.map((obj) => obj.Name).join(', ') : '';
            item.IndustryTypeShortString = item.IndustryType.length>0 ? item.IndustryType[0].Name : 'N/A';
        });
    }

    const getIndustryType = async () => {
        let industryTypePayload = {
            Type: 3,
        }
        var industryTypeResponse = await GetIndustryType(industryTypePayload);
        setIndustryTypeList(industryTypeResponse.data);
        setLoading(false);
    }

    const handleIndustryTypeFilter = (e) => {
        const industryType = e.target.value;
        if (industryType !== '') {
            let filteredCompanies = filteredData.filter(item => item.IndustryType.some(industry => industry.Name === industryType));
            setData(filteredCompanies);
        }
        else {
            setData(filteredData);
        }
    }

    useEffect(() => {
        getOrganization();
        getIndustryType();
        const role = getRoles(userInfo);
        setRole(role);
        setTimeout(() => {
            if(role === 'Grok Admin') { //Grok Admin
                document.getElementById('nav-dropdownSuperadmin').parentElement.classList.add('show');
                document.getElementById('nav-dropdownSuperadmin').nextSibling.classList.add('show');
            }
            else {
                // Error handler
            }
            
        }, 300);
    }, [userInfo])


    return (
        <div className='page'>
        {loading ? <GrokLoading /> : ""}
            <NavMenu />
            <Header />
            <div className='page-wrapper'>
                <Container fluid>
                    {/* Start Page Header */}
                    <div className='page-header d-print-none'>
                        <Row className='g-2 align-items-center pb-1'>
                            <div>
                                <Breadcrumb className="custom-breadcrumb">
                                    <Breadcrumb.Item onClick={() => addRefresh()}> Home</Breadcrumb.Item>
                                    <Breadcrumb.Item active> Industry Partner</Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                            <Col style={{ display: 'flex', alignItems: 'center' }}>
                                <Button className='nave-icon' variant='outline' size='sm' title='Industry Partner'>
                                    <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" aria-hidden="true" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M3 2.25a.75.75 0 000 1.5v16.5h-.75a.75.75 0 000 1.5H15v-18a.75.75 0 000-1.5H3zM6.75 19.5v-2.25a.75.75 0 01.75-.75h3a.75.75 0 01.75.75v2.25a.75.75 0 01-.75.75h-3a.75.75 0 01-.75-.75zM6 6.75A.75.75 0 016.75 6h.75a.75.75 0 010 1.5h-.75A.75.75 0 016 6.75zM6.75 9a.75.75 0 000 1.5h.75a.75.75 0 000-1.5h-.75zM6 12.75a.75.75 0 01.75-.75h.75a.75.75 0 010 1.5h-.75a.75.75 0 01-.75-.75zM10.5 6a.75.75 0 000 1.5h.75a.75.75 0 000-1.5h-.75zm-.75 3.75A.75.75 0 0110.5 9h.75a.75.75 0 010 1.5h-.75a.75.75 0 01-.75-.75zM10.5 12a.75.75 0 000 1.5h.75a.75.75 0 000-1.5h-.75zM16.5 6.75v15h5.25a.75.75 0 000-1.5H21v-12a.75.75 0 000-1.5h-4.5zm1.5 4.5a.75.75 0 01.75-.75h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75h-.008a.75.75 0 01-.75-.75v-.008zm.75 2.25a.75.75 0 00-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 00.75-.75v-.008a.75.75 0 00-.75-.75h-.008zM18 17.25a.75.75 0 01.75-.75h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75h-.008a.75.75 0 01-.75-.75v-.008z" clipRule="evenodd"></path></svg></span>
                                </Button>
                                <h2 className="page-title"> Industry Partner</h2>
                            </Col>
                            <Col className="mb-1 me-3 col-md-auto">
                                <button className='newBtn_style' onClick={() => BackBtn()}>
                                    <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M249.38 336L170 256l79.38-80m-68.35 80H342"></path><path fill="none" strokeMiterlimit="10" strokeWidth="32" d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"></path></svg></span>
                                    &nbsp;&nbsp;Back
                                </button>
                            </Col>
                        </Row>
                    </div>
                    {/* End Page Header */}
                    <div className='py-3'>
                        <div className='card mb-3 mb-lg-5 '>
                            {/* Header */}
                            <div className='card-header'>
                                <Row className="row justify-content-between align-items-center flex-grow-1">
                                    <Col className='col-md mb-2 md-mb-0'>
                                        <div className="d-flex justify-content-between align-items-center">
                                            {/* <div className="card-title fw-bold mb-0">Company list
                                        </div> */}
                                        </div>
                                    </Col>
                                    {/* End Col */}
                                    <Col className='col-12 col-md-auto ms-auto d-print-none'>
                                        {/* <div className="form-group position-relative">
                                            <form className="d-flex mb-2 mb-md-0">
                                                <div className="form-group position-relative">
                                                    <input className="form-control leftpadding" id="text" variant="outlined" placeholder='Industry Partner' onChange={handleName} />
                                                </div>
                                            </form>
                                        </div> */}
                                    </Col>
                                    {(role === 'Grok Admin') && <Col lg={3}>
                                        <Form.Select as="select" onChange={(e) => handleIndustryTypeFilter(e)}>
                                            <option value={''}>Industry Vertical</option>
                                            {industryTypeList.map((item) => 
                                                <option key={item._id} option={item._id}>{item.Name}</option>
                                            )}
                                        </Form.Select>
                                    </Col>}
                                    {(role === 'Grok Admin') && <Col className='col-12 col-md-auto ms-auto d-print-none'>
                                        <button className="ms-3 mb-2 mb-lg-1 disable_btn" type="checkbox" variant="secondary" size="sm" hidden={!isChecked} onClick={handleMultipleDelete} >
                                            <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 448 512" height="1em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"></path></svg></span>
                                        </button>
                                        <button className="ms-3 mb-2 mb-lg-1 disable_btn" type="checkbox" variant="secondary" size="sm" hidden={!isEnabledItem} onClick={handleMultipleDisable}>
                                            <span><svg height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" role="img"><path fill="var(--ci-primary-color, currentColor)" d="M425.706,86.294A240,240,0,0,0,86.294,425.705,240,240,0,0,0,425.706,86.294ZM256,48A207.1,207.1,0,0,1,391.528,98.345L98.345,391.528A207.1,207.1,0,0,1,48,256C48,141.309,141.309,48,256,48Zm0,416a207.084,207.084,0,0,1-134.986-49.887l293.1-293.1A207.084,207.084,0,0,1,464,256C464,370.691,370.691,464,256,464Z"></path></svg>&nbsp;Deactivate</span>
                                        </button>
                                        <button className="ms-3 mb-2 mb-lg-1 enable_btn" type="checkbox" variant="secondary" size="sm" hidden={!isDisabledItem} onClick={handleMultipleEnable}>                                            
                                            <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.1em" width="1.1em" xmlns="http://www.w3.org/2000/svg"><path d="M362.6 192.9L345 174.8c-.7-.8-1.8-1.2-2.8-1.2-1.1 0-2.1.4-2.8 1.2l-122 122.9-44.4-44.4c-.8-.8-1.8-1.2-2.8-1.2-1 0-2 .4-2.8 1.2l-17.8 17.8c-1.6 1.6-1.6 4.1 0 5.7l56 56c3.6 3.6 8 5.7 11.7 5.7 5.3 0 9.9-3.9 11.6-5.5h.1l133.7-134.4c1.4-1.7 1.4-4.2-.1-5.7z"></path><path d="M256 76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256s-18.7 93.3-52.7 127.3S304.1 436 256 436c-48.1 0-93.3-18.7-127.3-52.7S76 304.1 76 256s18.7-93.3 52.7-127.3S207.9 76 256 76m0-28C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"></path></svg>&nbsp;
                                            Activate</span>
                                        </button>
                                        <button className="ms-2 backBtn_style" onClick={() => addCompany()} >
                                            Add Industry Parter
                                        </button>
                                    </Col>}
                                </Row>
                                {/* End Row */}
                            </div>
                            <div className='taablist'>
                              <DataTableExtensions {...tableData}>
                                  <DataTable
                                      columns={columns}
                                      data={data}
                                      fixedHeader
                                      defaultSortField="id"
                                      defaultSortAsc={false}
                                      pagination
                                      paginationPerPage={20}
                                      paginationRowsPerPageOptions={[20, 30, 50, 100]}
                                      selectableRows={(role === 'Grok Admin') ? true :false}
                                      onSelectedRowsChange={handleSelect}
                                      clearSelectedRows={clearRows}
                                  />
                              </DataTableExtensions>
                            </div>
                        </div>
                    </div>
                </Container>
                <Footer />
            </div>
        </div>
    )
}

export default Company; 